import { render, staticRenderFns } from "./editCommitteeModal.vue?vue&type=template&id=18f61f5b&scoped=true&"
import script from "./editCommitteeModal.vue?vue&type=script&lang=js&"
export * from "./editCommitteeModal.vue?vue&type=script&lang=js&"
import style0 from "./editCommitteeModal.vue?vue&type=style&index=0&id=18f61f5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f61f5b",
  null
  
)

export default component.exports